// ============================================================================
// Mining Requirements - Requirements for mining actions
// ============================================================================
import { createEquippedItemRequirement, createHasPawnSelectedRequirement, createItemTierRequirement, createSkillLevelRequirement, } from '../actions/requirements.js';
import { getOreTier, isOreDeposit } from './types.js';
/**
 * Get the requirements for mining a specific ore type.
 * Returns requirements that must be met to mine the ore.
 */
export const getMiningRequirements = ({ oreObjectType, oreName, }) => {
    const oreTier = getOreTier({ objectType: oreObjectType });
    // Not an ore - no mining requirements
    if (!oreTier) {
        return [];
    }
    const requirements = [];
    // Must have a pawn selected
    requirements.push(createHasPawnSelectedRequirement());
    // Must have a pickaxe equipped
    requirements.push(createEquippedItemRequirement({ itemCategory: 'pickaxe' }));
    // Must have sufficient mining level for this ore
    if (oreTier.miningLevelRequired > 1) {
        requirements.push(createSkillLevelRequirement({
            skillId: 'mining',
            minLevel: oreTier.miningLevelRequired,
        }));
    }
    // Pickaxe must be strong enough for the ore hardness
    if (oreTier.hardness > 1) {
        requirements.push(createItemTierRequirement({
            itemCategory: 'pickaxe',
            minTier: oreTier.hardness,
            targetName: oreName,
        }));
    }
    return requirements;
};
/**
 * Get the requirements for mining any object that requires a pickaxe (rocks, ores).
 * For ores, includes tier and skill requirements. For rocks, just needs a pickaxe.
 */
export const getPickaxeRequirements = ({ objectType, objectName, }) => {
    // For ores, use the full mining requirements (includes tier/skill checks)
    if (isOreDeposit({ objectType })) {
        return getMiningRequirements({ oreObjectType: objectType, oreName: objectName });
    }
    // For rocks, just need a pawn and a pickaxe (any tier works)
    return [
        createHasPawnSelectedRequirement(),
        createEquippedItemRequirement({ itemCategory: 'pickaxe' }),
    ];
};
//# sourceMappingURL=requirements.js.map